import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Toaster } from './ui/sonner';

export default function Layout() {
  return (
    <div className="min-h-screen bg-canvas">
      <Sidebar />
      <main className="ml-64 min-h-screen">
        <div className="p-6 md:p-8">
          <Outlet />
        </div>
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
}
